export default "__VITE_ASSET__BhRSBc77__"